var map = {
	"./bird.jpg": 59380,
	"./boy 01.jpg": 26246,
	"./boy 02.jpg": 84017,
	"./boy.jpg": 39083,
	"./boy1.jpg": 2806,
	"./dol 1.jpg": 85317,
	"./dol 2.jpg": 62714,
	"./dol.jpg": 55264,
	"./school boy 1.jpg": 72574,
	"./smal lion.jpg": 53614,
	"./teddy.jpg": 15939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53503;